// 获取当前pageName home_page chat_page chat_history_page

import { usePathname, useSearchParams } from 'next/navigation';

export enum PageName {
  HOME_PAGE = 'home_page',
  CHAT_PAGE = 'chat_page',
  HISTORY_PAGE = 'chat_history_page',
  UNKNOWN = 'unknown',
  SHARE_PAGE = 'share',
}

// 展示切换模型的页面
const SHOW_MODELS_PAGE_ = [PageName.HOME_PAGE, PageName.CHAT_PAGE];

export default function usePageName() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const getPageName = () => {
    if (pathname === '/') {
      // 如果searchParams有type=chat，则是chat_page TODO 后面修改/chat 目录结构的时候需要修改
      if (searchParams?.get('type') === 'chat') {
        return PageName.CHAT_PAGE;
      }
      return PageName.HOME_PAGE;
    }
    if (pathname?.includes('/history')) {
      return PageName.HISTORY_PAGE;
    }
    if (pathname?.includes('/share')) {
      return PageName.SHARE_PAGE;
    }
    return PageName.UNKNOWN;
  };
  return {
    isShowModelsPage: SHOW_MODELS_PAGE_.includes(getPageName()),
    isHistoryPage: pathname?.includes('/history'),
    getPageName,
  };
}
